<footer [className]="footerExpand ? 'footer footer-full' : 'footer'">
  <div *ngIf="!isMobile" class="footer-wrapper">
    <div class="float-left footer-nav">
      <a class="footer-nav-link" href="https://www.idi-insulation.com/" target="_blank" i18n>IDI Distributors</a> |
      <a class="footer-nav-link" href="assets/pdf/Bidit_EULA_{{locale}}.pdf" target="_blank" download i18n>License Agreement</a> |
      <a class="footer-nav-link" href="#" (click)="showContactUs($event)" i18n>Contact Us</a>
    </div>
    <div class="float-right text-light footer-copyright">
      &copy;2020 <span i18n>IDI Distributors Inc. All Rights Reserved</span>
    </div>
    <div class="clearfix"></div>
  </div>  
</footer>
